import { configTypes } from '@/enums/configTypes';
import { groupItemRelationship } from './groupItemRelationship';

export class groupItem
{
	constructor() {
		this.itemID = 0;
		this.name = "";		
		this.groupItemRelationships = [];
	}
	itemID: number;
	name: string;
	azioniPreElaborazione: string;
	azioniPostElaborazione: string;
	dataCreazione: Date;
	dataModifica: Date;
	cancellato: boolean;

	configType: configTypes;
	groupItemRelationships: groupItemRelationship[];
}